import axios from 'axios'

export default {
  // Amazon Ludify:
  //AWS_LAMBDA_PUT_GETSIGNEDURL_ENDPOINT: 'https://yl2eagr9qb.execute-api.sa-east-1.amazonaws.com/BudimAPI/Budim/putfiles3singnerurl',
  //AWS_LAMBDA_DELETE_GETSIGNEDURL_ENDPOINT: 'https://yl2eagr9qb.execute-api.sa-east-1.amazonaws.com/BudimAPI/Budim/deletefiles3signedurl',
  getSignedURL(file) {
    let endpoint = `${process.env.URL_API}/arquivo/v1/file/upload`
    
    let formData = new FormData();
    formData.append('uploadfile', file);


    return axios.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem("token"))}` 
      }
    })
      .then((res) => {
        return Promise.resolve(res.data || '/')
      })
      .catch((err) => {
        console.error(err)
        return Promise.reject('/')
      })
  },
  deleteGetSignedURL(filePath) {
    let endpoint = `${process.env.URL_API}/arquivo/v1/file/delete/` + filePath

    return axios.get(endpoint, {
      headers: {
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem("token"))}` 
      }
    })
      .then((res) => {
        return Promise.resolve(res.data.url || '/')
      })
      .catch((err) => {
        console.error(err)
        return Promise.reject('/')
      })
  }
}


// WEBPACK FOOTER //
// ./src/aws/lambda.js